import _asyncToGenerator from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/app/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import axios from 'axios';
import { resolve } from 'path';
import { RUNTIME_ENV } from "../../constants/env";
import { now } from "../../utils/now";
var api = axios;
api.interceptors.request.use();
export var RPC = /*#__PURE__*/function () {
  function RPC(opts) {
    _classCallCheck(this, RPC);

    _defineProperty(this, "axios", axios.create({
      headers: {
        'Content-Type': 'application/json'
      }
    }));

    _defineProperty(this, "_opts", void 0);

    _defineProperty(this, "envEndpoints", void 0);

    _defineProperty(this, "endpoint", void 0);

    if (!opts.envEndpoints && !opts.endpoint) throw new Error('At least set one endpoint');
    this._opts = opts;
  }

  _createClass(RPC, [{
    key: "rpc",
    value: function rpc(path, method, params, config) {
      var json = {
        jsonrpc: '2.0',
        id: now(),
        method: method,
        params: null
      };

      if (params) {
        json.params = Array.isArray(params) ? params : [params];
      }

      var url = this.getUrl(path);
      return this.axios.post(url, json, config).then(function (resp) {
        var _resp$data;

        return (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : _resp$data.result;
      });
    }
  }, {
    key: "getUrl",
    value: function getUrl(path) {
      var _this$_opts = this._opts,
          envEndpoints = _this$_opts.envEndpoints,
          endpoint = _this$_opts.endpoint;
      var url = new URL(endpoint || envEndpoints[RUNTIME_ENV]);

      if (path === '/') {
        return url.href;
      }

      url.pathname = resolve(url.pathname, path);
      return url.href;
    }
  }]);

  return RPC;
}();
export var baseRpc = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(endpoint, method, params, config) {
    var json, url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            json = {
              jsonrpc: '2.0',
              id: now(),
              method: method,
              params: null
            };

            if (params) {
              json.params = Array.isArray(params) ? params : [params];
            }

            url = new URL(endpoint);
            return _context.abrupt("return", axios.post(url.href, json, config).then(function (resp) {
              var _resp$data2;

              return (_resp$data2 = resp.data) === null || _resp$data2 === void 0 ? void 0 : _resp$data2.result;
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function baseRpc(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();